"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.versionLink = void 0;
const context_1 = require("@apollo/client/link/context");
const config_1 = __importDefault(require("next/config"));
const { publicRuntimeConfig = {} } = (0, config_1.default)() || {};
const { clientName, brand } = publicRuntimeConfig;
exports.versionLink = (0, context_1.setContext)((request, { headers }) => __awaiter(void 0, void 0, void 0, function* () {
    return {
        headers: Object.assign(Object.assign({}, headers), { 'graphql-client-version': process.env.VERSION, 'graphql-client-name': clientName || brand || `unknown` }),
    };
}));
//# sourceMappingURL=versionLink.js.map